import React, { useRef } from 'react';

const OtpInput = ({ length = 6, onChange }) => {
  const inputRefs = useRef([]);

  const handleChange = (index, value) => {
    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
    const otpValues = inputRefs.current.map((ref) => ref.value).join('');
    onChange(otpValues);
  };

  const handleKeyDown = (index, event) => {
    if (event.key === 'Backspace' && !inputRefs.current[index].value) {
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text/plain').slice(0, length);
    for (let i = 0; i < length; i++) {
      inputRefs.current[i].value = pasteData[i] || '';
      handleChange(i, pasteData[i]);
    }
  };

  const handleFocus = (index) => {
    // console.log(inputRefs.current[index])
    if (inputRefs.current[index] !== undefined) {
      return inputRefs.current[index].select();
    }
  };


  // <Input className='form-control text-center opt-text' type='text' value='00' maxlength='2' />
  return (
    <div className="d-flex justify-content-center gap-4">
      {Array.from({ length }, (_, index) => (
        <input
          key={index}
          ref={(ref) => (inputRefs.current[index] = ref)}
          type="text"
          maxLength={1}
          autoFocus={index === 0}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onFocus={() => handleFocus(index)}
          onPaste={(e) => handlePaste(e)}
          className='form-control text-center opt-text'
        />
      ))}
    </div>
  );
};

export default OtpInput;
